import { useCallback, useEffect, useRef, useState } from "react";

// Same behaviour as the toast in Home.jsx, packaged so other screens can reuse it.
export default function useToast() {
    const [toast, setToast] = useState(null); // { type: 'success' | 'error', message }
    const timerRef = useRef(null);

    const dismissToast = useCallback(() => {
        if (timerRef.current) {
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setToast(null);
    }, []);

    const showToast = useCallback((type, message, duration = 3500) => {
        if (timerRef.current) window.clearTimeout(timerRef.current);
        setToast({ type, message });
        timerRef.current = window.setTimeout(() => {
            setToast(null);
            timerRef.current = null;
        }, duration);
    }, []);

    useEffect(
        () => () => {
            if (timerRef.current) window.clearTimeout(timerRef.current);
        },
        []
    );

    return { toast, showToast, dismissToast };
}